var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.99611C8 6.67668 7.88539 6.4118 7.64088 6.16249L1.7574 0.296049C1.55874 0.0934892 1.32187 3.81218e-09 1.03916 2.99686e-09C0.466094 1.34418e-09 -1.32561e-09 0.459655 -3.01071e-09 1.04396C-3.84202e-09 1.33222 0.122254 1.59711 0.328558 1.80746L5.55492 6.98831L0.328558 12.1848C0.122254 12.3951 -3.6488e-08 12.6522 -3.73418e-08 12.9482C-3.90269e-08 13.5326 0.466094 14 1.03916 14C1.32187 14 1.55874 13.8987 1.7574 13.6962L7.64088 7.82972C7.89303 7.58041 8 7.31553 8 6.99611Z",
    fill: "#07364B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronright);
export default __webpack_public_path__ + "static/media/chevron.right.85ce2667f965cf86e6f70ef6c969e760.svg";
export { ForwardRef as ReactComponent };